import React, {Component} from 'react';

import Popup from '../Popup/index';

import Registry from '../../../registry/index';
import { openOptions } from '../SidebarMenu/index';

class PmDisabledPopup extends Popup {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    componentDidMount() {
        super.componentDidMount();

        this.setState({
            ...super.state,
        });
    }

    componentWillReceiveProps(nextProps) {
        let {currentUser} = nextProps;

        this.setState({disabled: currentUser.isAnonymous()});
    }

    onSubmit(e) {
        e.preventDefault();
        this.close();
        openOptions(this.props.currentUser);
    }

    render() {
        let lang = Registry.get('locale');

        let className = 'popup popup-NotEnoughTokensPopup popup-PmDisabledPopupPopup ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="top">
                    <div className="close" onClick={() => this.close()}/>
                </div>
                <div className="content">
                    <div className="text">{lang.pm_disabled_info}</div>
                    <button onClick={this.onSubmit}>{lang.settings}</button>
                </div>
            </div>
        )
    }
}

PmDisabledPopup.generateKey = function(props) { return 'PmDisabledPopup-popup' };
PmDisabledPopup.mount = function(props, onMount) { return Popup.mount(PmDisabledPopup, props, onMount) };
PmDisabledPopup.open = function(props) {
    var id = PmDisabledPopup.generateKey(props);

    if (!Popup.popups[id]) {
        PmDisabledPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open()
    }
};

export default PmDisabledPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmDisabledPopup/index.js